export const VIEWED_HOMEPAGE_CONCEPT_0 = 'Viewed Homepage Concept 0';
export const VIEWED_HOMEPAGE_CONCEPT_1 = 'Viewed Homepage Concept 1';
export const VIEWED_HOMEPAGE_CONCEPT_2 = 'Viewed Homepage Concept 2';
